export default function SolarSystemsElPaso() {
  const systems = [
    {
      image: 'https://public.readdy.ai/ai/img_res/28abfe9787530b8388c22f266c122109.jpg',
      title: 'Grid-Tied Solar Systems',
      features: ['Net Metering', 'Lower Costs', 'Utility Backup', 'Tax Credits'],
      description: 'Connected to the electrical grid, allowing you to sell excess power back to the utility company and draw power when needed'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=residential%20home%20with%20off%20grid%20solar%20panel%20array%20and%20battery%20storage%20system%20installation%20showing%20complete%20energy%20independence%20setup%20with%20backup%20power%20in%20remote%20location%20with%20clear%20blue%20sky&width=600&height=400&seq=solar-system-2&orientation=landscape',
      title: 'Off-Grid Solar Systems',
      features: ['Energy Independence', 'Battery Storage', 'Remote Locations', 'No Utility Bills'],
      description: 'Completely independent solar systems with battery storage, perfect for remote properties or achieving total energy autonomy'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20home%20rooftop%20with%20hybrid%20solar%20power%20system%20combining%20grid%20connection%20and%20battery%20backup%20storage%20showing%20advanced%20renewable%20energy%20technology%20installation%20in%20residential%20setting%20with%20bright%20sunshine&width=600&height=400&seq=solar-system-3&orientation=landscape',
      title: 'Hybrid Solar Systems',
      features: ['Grid + Battery', 'Backup Power', 'Flexibility', 'Peak Shaving'],
      description: 'Combines grid connection with battery storage for the best of both worlds—backup power during outages and grid benefits'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=large%20commercial%20building%20rooftop%20covered%20with%20extensive%20solar%20panel%20array%20installation%20showing%20industrial%20scale%20renewable%20energy%20system%20for%20business%20operations%20under%20clear%20sky%20in%20urban%20setting&width=600&height=400&seq=solar-system-4&orientation=landscape',
      title: 'Commercial Solar Arrays',
      features: ['High Capacity', 'ROI Focused', 'Tax Benefits', 'Sustainability'],
      description: 'Large-scale solar installations designed for businesses to significantly reduce operational costs and carbon footprint'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=residential%20property%20with%20ground%20mounted%20solar%20panel%20system%20installation%20in%20backyard%20showing%20alternative%20mounting%20solution%20with%20adjustable%20angle%20panels%20on%20metal%20framework%20in%20sunny%20outdoor%20setting&width=600&height=400&seq=solar-system-5&orientation=landscape',
      title: 'Ground-Mounted Solar',
      features: ['Optimal Angle', 'Easy Access', 'Scalable', 'No Roof Impact'],
      description: 'Solar panels installed on ground-level mounting systems, ideal for properties with limited roof space or optimal ground positioning'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=modern%20home%20with%20solar%20panel%20carport%20structure%20providing%20covered%20parking%20while%20generating%20clean%20energy%20showing%20dual%20purpose%20installation%20with%20sleek%20design%20in%20residential%20driveway%20setting&width=600&height=400&seq=solar-system-6&orientation=landscape',
      title: 'Solar Carports & Canopies',
      features: ['Dual Purpose', 'Vehicle Shade', 'EV Charging', 'Space Efficient'],
      description: 'Solar installations that provide covered parking or outdoor shade while generating clean energy for your property'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Solar System Options for El Paso Properties
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Explore different solar installation types designed to maximize El Paso's abundant sunshine and meet your specific energy needs
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {systems.map((system, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow"
            >
              <div className="w-full h-64">
                <img
                  src={system.image}
                  alt={system.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {system.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {system.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {system.features.map((feature, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-amber-50 text-amber-700 rounded-full text-sm font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
